import Cargos from '@/models/Cargos'

import lancamentoRotas from './routes/lancamento.routes'
import clientesRotas from './routes/clientes.routes'
import painelRotas from './routes/painel.routes'
import fechamentoRotas from './routes/fechamento.routes'

// eslint-disable-next-line
export const rotasAtendimento = {
  modulo: 'atendimento',
  label: 'Atendimento',
  icon: 'hands-helping',
  mostrarMenu: true,
  cargos: [Cargos.ATENDENTE, Cargos.BARBEIRO, Cargos.LIDER, Cargos.BARBEIRO_CAIXA],
  rotas: [...painelRotas, ...lancamentoRotas, ...clientesRotas, ...fechamentoRotas],
}
